import AddressDTO from "features/customer/dtos/AddressDTO";
import React from "react";
import { useTranslation } from "react-i18next";
import { getAddressSections } from 'features/shared/helpers/AddressFormatter';

interface Props {
  address: AddressDTO;
  className?: string;
}

const AddressFormatter = ({ address, className }: Props) => {
  // translation
  const { t } = useTranslation(["shared\\enums\\country"]);
  // formatted address sections
  const addressSections = getAddressSections(address);

  // render 
  return (
    <div className={className}>
      <div>{addressSections.streetSection}</div>
      <div>{addressSections.citySection}</div>
      <div>{t(addressSections.countryCodeSection)}</div>
    </div>
  );
};

export default AddressFormatter;
